import React from 'react';

const ReportImage = ({ onError }) => {
  return (
    <img
      src={process.env.PUBLIC_URL + "/NASDAQ_PIZZA_2023_10K.jpg"}
      alt="10-K Preview"
      onError={onError}
      className="rounded-lg shadow-lg border max-h-[60vh] w-auto object-contain"
    />
  );
};

export default ReportImage;
